import BaseService from './baseService';

export default class ActionTokenService extends BaseService {
    handleToken(id, token) {
        const url = `${window.API_URL}/api/actionToken/verify?id=${id}&token=${token}`;
        return this.axiosApiInstance.get(url)
            .then(res => res.data)
            .catch(err => super.handleHttpError(err));
    }
}
